import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct } from '../store/product-state';

@Injectable({
  providedIn: 'root',
})
export class ManualPriceFacade {
  constructor(private store: Store<StateWithProduct>) {}

  productCardManualPriceInit(): void {
    this.store.dispatch(new CustomProductActions.ProductCardManualPriceInit());
  }
}
